if (!customElements.get('pro-package')) {
  customElements.define(
    'pro-package',
    class ProPackage extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.pro-package__checkbox');
        this.proPackageHandle = null;
        this.currentColor = null;
        this.proPackageVariants = null;
        this.init();
      }

      async init() {
        if (!this.checkbox) return;

        // Get the pro package product handle from the checkbox
        this.proPackageHandle = this.checkbox.dataset.proPackageHandle;
        // Fetch pro package product data to get variants for color matching
        if (this.proPackageHandle) {
          await this.fetchProPackageVariants();
        }

        // Store the current color from the selected variant
        this.storeCurrentColor();

        // Listen for checkbox changes
        this.checkbox.addEventListener('change', this.onProPackageToggle.bind(this));

        // Listen for variant changes to update the current color
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }

      async fetchProPackageVariants() {
        if (!this.proPackageHandle || this.proPackageHandle === '') return;

        try {
          const response = await fetch(`/products/${this.proPackageHandle}.js`);
          const productData = await response.json();
          this.proPackageVariants = productData.variants;
        } catch (error) {
          console.error('Failed to fetch pro package variants:', error);
        }
      }

      storeCurrentColor() {
        // Get the currently selected color from the color variant selection
        const colorSelection = document.querySelector('color-variant-selection');
        if (colorSelection) {
          const selectedColorInput = colorSelection.querySelector('input[type="radio"]:checked');
          if (selectedColorInput) {
            this.currentColor = selectedColorInput.dataset.variantTitle;
          }
        }
      }

      onProPackageToggle(event) {
        const isChecked = event.target.checked;

        // Redirect to the relative upgrade/original product
        const proUpgrade = this.checkbox.dataset.proUpgrade == 'true';
        if (proUpgrade) {
          this.redirectToRelativeUpgrade();
        }
      }

      onVariantChange(event) {
        // Update the current color when variants change
        if (event.detail.variant) {
          this.currentColor = event.detail.variant.title;
          this.updateMsrpDisplay(event.detail.variant.id);
        }
      }

      updateMsrpDisplay(variantId) {
        const msrpEl = this.querySelector('.pro-package__msrp');
        if (!msrpEl) return;

        const formattedMsrp = msrpEl.getAttribute(`data-msrp-${variantId}`);
        if (formattedMsrp) {
          msrpEl.textContent = `MSRP ${formattedMsrp}`;
          msrpEl.hidden = false;
        } else {
          msrpEl.hidden = true;
        }
      }

      redirectToRelativeUpgrade() {
        try {
          let targetUrl = '';
          // Redirect to related product
          if (!this.proPackageHandle || this.proPackageHandle === '') return;

          let proVariantId = null;
          if (Array.isArray(this.proPackageVariants) && this.proPackageVariants.length > 0) {
            const proVariant = this.findMatchingProPackageVariant();
            proVariantId = proVariant ? proVariant.id : this.proPackageVariants[0].id;
          }
          targetUrl = `/products/${this.proPackageHandle}` + (proVariantId ? `?variant=${proVariantId}` : '') + `&view=stroller`;
         
          if (targetUrl) {
            window.location.href = targetUrl;
          }
        } catch (e) {
          console.error('Redirection failed:', e);
        }
      }

      findMatchingProPackageVariant() {
        if (!this.proPackageVariants || this.proPackageVariants.length === 0 || !this.currentColor) return null;

        // Look for a variant that matches the current color
        return this.proPackageVariants.find(variant => {
          // Check if any of the variant's option values match the current color
          return variant.option1 === this.currentColor || 
                 variant.option2 === this.currentColor || 
                 variant.option3 === this.currentColor;
        });
      }
    }
  );
}
